// Placeholder for client/src/components/Footer.jsx
// Footer.jsx
import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white text-center py-4 mt-10">
      <p className="text-sm">&copy; {new Date().getFullYear()} Udaikulam Village Portal</p>
      <p className="text-xs">Developed for the people of Udaikulam ❤️</p>
    </footer>
  );
};

export default Footer;
